import React from 'react'
import _ from 'lodash'

import OrderActions from '../../actions/OrderActions.js'
import t from '../../helpers/Languages.js'

import {Alert, IconButton, S1, Row, Colors, H6, Card} from '../UI/index.js'
import {FormRow, FormStack, Input, Select, Toggle, formSpacing} from '../UI/forms/index.js'
import EditAddress from './EditAddress.js'

class MoreOptions extends React.PureComponent {
    constructor(props) {
        super(props)

        this.initialState = {
            order: null,
            retourAddress: {},
            allowAddCollo: '',
            edit: false,
            expanded: false,
            priceLoading: false,
            loading: false,
            error: '',
            message: ''
        }

        this.state = structuredClone(this.initialState)
    }

    componentDidMount() {
        this.setState({
            order: structuredClone(this.props.order),
            retourAddress: this.props.order.retourAddress,
            allowAddCollo: this.props.order.allowAddCollo
        })
    }

    // Whether the options are being edited and differ from the order, used to warn before closing the order
    hasChanges() {
        const {edit, retourAddress, allowAddCollo} = this.state
        const {order} = this.props

        return edit && (!_.isEqual(retourAddress, order.retourAddress) || allowAddCollo !== order.allowAddCollo)
    }

    saveChanges(callback) {
        this.save(callback)
    }

    save(callback) {
        const {retourAddress, allowAddCollo} = this.state
        const {order} = this.props

        this.setState({loading: true, error: ''})

        OrderActions.editMoreOptions(order._id, retourAddress, allowAddCollo, (err, order) => {
            if (err) {
                this.setState({loading: false, error: err})
            } else {
                this.setState({loading: false, edit: false, error: ''})

                this.props.onUpdateOrder(order)
            }

            typeof callback === 'function' && callback(err)
        })
    }

    render() {
        const {order, expanded, edit, retourAddress, allowAddCollo, error} = this.state
        const {reseller} = this.props

        return (
            <div style={{marginBottom: 24, width: '100%'}}>
                <Row style={{alignItems: 'center', minHeight: 36}}>
                    <Row style={{cursor: 'pointer'}} onClick={() => this.setState({expanded: !expanded})}>
                        <S1>{t('otherOptions')}</S1>
                        <i style={{marginLeft: 6}}className={expanded ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
                    </Row>

                    <div style={{flex: 1}} />

                    {!edit && expanded &&
                        <IconButton
                            icon='mdi mdi-pencil'
                            onClick={() => this.setState({edit: !edit})}
                        />
                    }

                    {edit &&
                        <IconButton
                            icon='mdi mdi-check'
                            onClick={() => this.save()}
                        />
                    }
                </Row>

                {expanded &&
                    <div style={{marginBottom: 12, width: '100%', padding: 6}}>
                        {/* With more than one address, also one pickup and one delivery address */}
                        {order.addresses?.length > 1 &&
                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                <FormRow>
                                    <Select
                                        label={t('addressOrder')}
                                        info={t('addressOrderInfo')}
                                        options={[
                                            {title: t('addressOrderFixed'), value: 'fixed'},
                                            {title: t('addressOrderRandom'), value: 'random'}
                                        ]}
                                        value={order.addressOrder || 'fixed'}
                                        readOnly
                                    />
                                    <div style={{flex: 1}} />
                                </FormRow>
                            </FormStack>
                        }

                        {!reseller.isShop && (!order.templateId || (order.autoRetour && order.nrOfDeliveries > 0)) &&
                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                {!reseller.isShop && !order.templateId &&
                                    <FormRow>
                                        <Input
                                            label={t('nrOfDeliveries')}
                                            info={t('nrOfDeliveriesInfo')}
                                            type='number'
                                            value={order.nrOfDeliveries}
                                            readOnly
                                        />

                                        <Toggle
                                            style={{marginLeft: 12}}
                                            label={t('autoRetour')}
                                            checked={order.autoRetour}
                                            disabled
                                        />
                                    </FormRow>
                                }

                                {!reseller.isShop && order.autoRetour && order.nrOfDeliveries > 0 &&
                                    <FormRow>
                                        <Input
                                            label={t('nrOfDaysBeforeRetour')}
                                            info={t('nrOfDaysBeforeRetourInfo')}
                                            type='number'
                                            value={order.nrOfDaysBeforeRetour}
                                            readOnly
                                        />
                                        <div style={{flex: 1}} />
                                    </FormRow>
                                }
                            </FormStack>
                        }

                        {!reseller.isShop && order.autoRetour &&
                            <>
                                <H6 style={{marginBottom: 12, marginTop: 12}}>{t('returnAddress')}</H6>

                                <Card style={{width: '100%', background: Colors.grey20, padding: formSpacing.inset}}>
                                    <EditAddress
                                        address={{...retourAddress, type: 'delivery'}}
                                        onChange={(address) => this.setState({retourAddress: address})}
                                        readOnly={!edit || this.props.sharedReadOnly}
                                        ref={(ref) => this.retourAddress = ref}
                                        reseller={reseller}
                                    />
                                </Card>
                            </>
                        }

                        <FormStack style={{marginTop: formSpacing.rowGap, marginBottom: formSpacing.rowGap}}>
                            <FormRow>
                                <Select
                                    label={t('allowAddCollo')}
                                    options={[
                                        {title: t('yes'), value: 'yes'},
                                        {title: t('allowAddColloDeliver'), value: 'deliver'},
                                        {title: t('allowAddColloPickup'), value: 'pickup'},
                                        {title: t('no'), value: ''}
                                    ]}
                                    value={allowAddCollo}
                                    onChange={(event) => this.setState({allowAddCollo: event.target.value})}
                                    readOnly={!edit}
                                />
                                <div style={{flex: 1}} />
                            </FormRow>

                            {reseller.settings.orders.monitorTemperature &&
                                <Toggle
                                    style={{width: '50%', marginTop: 12}}
                                    label={t('monitorTemperature')}
                                    checked={order.monitorTemperature}
                                    disabled
                                />
                            }

                            {order.monitorTemperature &&
                                <FormRow>
                                    <Select
                                        label={t('sensorId')}
                                        value={order.sensorId}
                                        readOnly
                                    >
                                        {(reseller.settings.orders.sensors || []).map((sensor) => {
                                            return (
                                                <option key={sensor.id} value={sensor.sensorId}>{sensor.name}</option>
                                            )
                                        })}
                                    </Select>

                                    <div style={{display: 'flex', columnGap: formSpacing.columnGap}}>
                                        <Input
                                            id='minTemperature'
                                            type='number'
                                            label={t('minTemperature')}
                                            value={order.minTemperature}
                                            readOnly
                                        />

                                        <Input
                                            id='maxTemperature'
                                            type='number'
                                            label={t('maxTemperature')}
                                            value={order.maxTemperature}
                                            readOnly
                                        />
                                    </div>
                                </FormRow>
                            }
                        </FormStack>

                        {error &&
                            <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                        }
                    </div>
                }
            </div>

        )
    }
}

export default MoreOptions
